import React, { useContext } from "react";
import JumboLayout from "@jumbo/components/JumboLayout";
import Header from "../shared/headers/Header";
import Sidebar from "../shared/sidebars/Sidebar";
import Footer from "../shared/footers/Footer";
import useJumboLayout from "@jumbo/hooks/useJumboLayout";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import {SIDEBAR_STYLES} from "@jumbo/utils/constants";
import {headerTheme as theme4} from "../../themes/header/theme4";
import {headerTheme as defaultTheme} from "../../themes/header/default";
import useApp from "../../hooks/useApp";
import layoutConfig from "./layoutConfig";
import { AppContext } from "app/AppContext";
import { createContext } from "react";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { useState } from "react";
import { authUserData } from "backendServices/ApiCalls";
import { useEffect } from "react";
import Div from "@jumbo/shared/Div/Div";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const CustomProvider = createContext();

const VerticalDefault = ({children}) => {
    const {setJumboLayoutOptions} = useJumboLayout();
    const {headerTheme, setHeaderTheme} = useJumboHeaderTheme();
    const {theme} = useJumboTheme();
    const appBarBgColor = headerTheme.components?.MuiAppBar?.styleOverrides?.root?.background;
    const {sidebarOptions} = useJumboLayoutSidebar();
    const appData = useApp();
    const [loginUserData, setloginUserData] = useState('')
    const [loading,setLoading]=useState(true)
    const [open, setOpen] = React.useState(false);
    const [alertData, setalertData] = useState({
        show:false,
        message:"",
        variant:""
    })
    const nav = useNavigate()
    const getUserData =()=>{ 
        setLoading(true)
        authUserData((response) => {
            setloginUserData(response?.data?.data)
            setLoading(false)
        }, (error) => {
            console.log(error?.response?.data);
            setLoading(false)            
        })
    }

    useEffect(()=>{
        getUserData();
    },[nav])
    // const {...authOptions} = useJumboAuth()
    // const loginUserData = authOptions

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false)
        setalertData({
            show:false,
            message:"",
            variant:""
        })
    };

    React.useEffect(() => {
        setJumboLayoutOptions(layoutConfig)
    }, []);

    const {checkLogin} = useContext(AppContext)
    const LoginStatus = checkLogin();
    React.useEffect(() => {

        if (appBarBgColor === "#F5F7FA" && sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER) {
            setHeaderTheme({...theme, ...theme4});
            appData.setAppState({
                prevHeaderBgColor: theme?.mode === "dark" ? "#222D45" :"#F5F7FA",
            });
        } else if (appData.prevHeaderBgColor && appData.prevHeaderBgColor === "#F5F7FA") {
            setHeaderTheme({...theme, ...defaultTheme});
        }

    }, [sidebarOptions.style]);


    return (
    <CustomProvider.Provider value={{loginUserData, setloginUserData, loading, open, setOpen, handleOpen, handleClose,alertData, setalertData}}>
        <JumboLayout
            header={LoginStatus && <Header/>}
            sidebar={LoginStatus && <Sidebar/>}
            footer={LoginStatus && <Footer loginUserData={loginUserData} />}
            headerSx={{
                height: 80,
            }}
        >
            {children}

        </JumboLayout>
    </CustomProvider.Provider>
    );
};

export default VerticalDefault;
export {CustomProvider};
